// Pure arrival classification. No React, no I/O.
// Colour values are sourced from the shared presentation config so a client
// can restyle statuses by overriding @core/config/arrivalPresentation.
import { mDiff, formatIsoTime } from './time.js'
import { arrivalPresentation } from '@core/config/arrivalPresentation'

const STATUS_COLORS = arrivalPresentation.status

export const isLate = (sched, live, lateThreshold = 5) => {
  if (!sched || !live) return false
  return mDiff(sched, live) >= lateThreshold
}

export const isEarly = (sched, live, earlyThreshold = -2) => {
  if (!sched || !live) return false
  return mDiff(sched, live) <= earlyThreshold
}

export const getArrivalStatus = (sched, live, earlyThreshold = -2, lateThreshold = 5) => {
  if (!sched || !live) {
    return { status: 'unknown', ...STATUS_COLORS.unknown }
  }

  let liveTime = live
  if (typeof live === 'string' && live.includes('T')) {
    liveTime = formatIsoTime(live)
  }

  if (!liveTime || liveTime === '-') {
    return { status: 'unknown', ...STATUS_COLORS.unknown }
  }

  if (isLate(sched, liveTime, lateThreshold)) {
    return { status: 'late', ...STATUS_COLORS.late }
  }
  if (isEarly(sched, liveTime, earlyThreshold)) {
    return { status: 'early', ...STATUS_COLORS.early }
  }
  return { status: 'on-time', ...STATUS_COLORS['on-time'] }
}
